var React = require('react');

function SlideLeft (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"y":"1","width":"30","height":"50","fill":"white","key":0}),React.createElement("path",{"d":"M12.28 26.686L17.321 31.786C17.695 32.164 18 32.038 18 31.502V20.502C18 19.966 17.7 19.84 17.321 20.218L12.28 25.318C12.1014 25.5009 12.0014 25.7464 12.0014 26.002C12.0014 26.2576 12.1014 26.5031 12.28 26.686Z","fill":"#ADADAD","key":1})]);
}

SlideLeft.defaultProps = {"width":"30","height":"50","viewBox":"0 0 30 50","fill":"none"};

module.exports = SlideLeft;

SlideLeft.default = SlideLeft;
